import React from 'react';
import { Segment, Header } from 'semantic-ui-react';
import UsersTable from '../../components/UsersTable';
import { isBD } from '../../helpers';

const User = () => {
  const bd = isBD();
  return (
    <>
      <Segment>
        <Header as='h3'>{bd ? '用户' : '管理用户'}</Header>
        <UsersTable readOnly={bd} bd={bd}/>
      </Segment>
    </>
  );
};

export default User;
